import React from "react"
import { Modal } from "@mimber/ui-web"
import { SuspendMemberForm } from "@/components/forms/SuspendMemberForm"
import type { SuspendMemberModalProps } from "./SuspendMemberModal.types"

export const SuspendMemberModal: React.FunctionComponent<
  SuspendMemberModalProps
> = ({ memberUuid, onSuccess, ...modalProps }) => {
  return (
    <Modal footer={null} title="Suspend Member" {...modalProps}>
      {(close) => (
        <SuspendMemberForm
          memberUuid={memberUuid}
          onSuccess={() => {
            close()
            onSuccess?.()
          }}
          onCancel={close}
        />
      )}
    </Modal>
  )
}
